import * as React from "react"
import Section from "../../../../core/layout/main/section/Section"
import * as classNames from "./MediaLogoSection.module.scss"
import Button from "../../blocks/button/Button"
import Icon from "../../blocks/icon/Icon"
import Image from "../../blocks/image/Image"

const MediaLogoSection = ({ title, description, btn, logos }) => {
  return (
    <Section className={classNames.mediaContainer}>
      <div className={classNames.left}>
        <h2>{title}</h2>
        <p>{description}</p>
        <div className={classNames.btn}>
          <Button
            aspect={"contrastant"}
            size={"medium"}
            color={"secondary"}
            href={"https://www.linkedin.com/company/paritel/posts/"}
            target="_blank"
          >
            <Icon
              icon="linkedin"
              color="white"
              width="22"
              height="22"
            />{" "}
            {btn}
          </Button>
        </div>
      </div>
      <div className={classNames.right}>
        <div className={classNames.logos}>
          {logos.map((logo, i) => (
            <div
              key={i}
              className={classNames.logoWrapper}
            >
              <Image
                dataSizesPreset={"S"}
                imgSrc={logo.attributes.url}
                imgAlt={logo.attributes.alternativeText}
                imgWidth={logo.attributes.width}
                imgHeight={logo.attributes.height}
                formats={logo.attributes?.formats}
              />
            </div>
          ))}
        </div>
      </div>
    </Section>
  )
}

export const name = "MediaLogoSection"

export const init = (componentData) => {
  return (
    <MediaLogoSection
      key={componentData.id}
      title={componentData.label}
      description={componentData.description}
      btn={componentData.buttonLabel}
      logos={componentData.logos.data}
    />
  )
}

export default MediaLogoSection
